// this is an autogenerated file from App/Account/Content/Tasks/mutation-update-task-assignee.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks($task_id: uuid!, $user_id: uuid!) {
  delete_tasks_assignees(where: { task_id: { _eq: $task_id } }) {
    affected_rows
  }
  insert_tasks_assignees(objects: { task_id: $task_id, user_id: $user_id }) {
    affected_rows
  }
}

`